module.exports = "<div class=\"add-container\" id=\"pwa-added\" (click)=\"addToHome()\">\n  <span> Add Web-Tailwind to home screen</span>\n</div>\n"